import React, { useState } from 'react';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { GrossOfFeeIcon } from '../../../GrossOfFeeIcon/GrossOfFeeIcon';
import { usePeriodReturn } from '../../../PeriodReturn/usePeriodReturn';
import { ValueVsInvestmentChart } from '../../../ValueVsInvestmentChart/ValueVsInvestmentChart';
import { StyledCard } from './ValueVsInvestmentCard.style';

interface Props {
  title: string;
}

export const ValueVsInvestmentCard = React.memo(({ title }: Props) => {
  const [, setSelectedDate] = useState<string | null>(null);

  const { data: periodReturnData } = usePeriodReturn();

  const portfolioReturn = periodReturnData?.value ? parseFloat(periodReturnData?.value) : null;

  return (
    <StyledCard>
      <Text variant="cardTitle" mb="12">
        {title}
        <GrossOfFeeIcon />
      </Text>

      <ValueVsInvestmentChart portfolioReturn={portfolioReturn} setSelectedDate={setSelectedDate} />
    </StyledCard>
  );
});
